import React from 'react';

const Loader = () => (
    <div className="app">
        <div>Loading...</div>
    </div>
);

export default Loader;